<template>
  <el-row class="editPanel">
    <el-col :span="24">
      <h3 :class="{closed: !panelOpen}">Checks</h3><span class="toggle" @click="panelOpen = panelOpen !== true" :class="{closed: !panelOpen}"></span>
      <transition name="panel">
        <div class="pea-panel checks-panel" v-if="panelOpen">
          <el-table :data="checkData" v-loading="tableLoading"
                    stripe class="peaCheckTable">
            <el-table-column prop="peaCheckTypeDescNote" style="word-wrap:normal" align="left"
                             label="Check">
              <template slot-scope="props">
                <el-row :gutter="20">
                  <el-col :span="3">
                    <tool-tip-popup :text="props.row.peaCheckTypeHelpNote" :showLink="true"></tool-tip-popup>
                  </el-col>
                  <el-col :span="17">
                    <div v-html="props.row.peaCheckTypeDescNote" style="word-wrap:normal"></div>
                  </el-col>
                </el-row>
              </template>

          </el-table-column>
          <el-table-column prop="isRequired" align="left"
                           label="Required">
            <template slot-scope="props">
              <el-checkbox v-model="props.row.isRequired" :disabled="true"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="isDone" align="left"
                           label="Performed">
            <template slot-scope="props">
              <el-checkbox v-model="props.row.isDone" :disabled="disabled"></el-checkbox>
            </template>
          </el-table-column>
      <el-table-column class-name="wrap" style="word-wrap:normal" align="left"
                       prop="comment"
                       label="Comment">
        <template slot-scope="props">
          <el-input :maxlength="700" type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="props.row.comment" :disabled="disabled"></el-input>
        </template>
      </el-table-column>
  </el-table>
  <el-pagination v-if="resultTotal > pageSize"
                 @current-change="fetchData"
                 :current-page.sync="currentPage"
                 :page-size="pageSize"
                 layout="total, prev, pager, next"
                 :total="resultTotal">
  </el-pagination>
  </div>
  </transition>
  </el-col>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'pea-check',
  props: {
    peaId:
    {
      default: 0
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      checkData: [],
      currentPage: 1,
      pageSize: 6,
      resultTotal: 0,
      panelOpen: true,
      tableLoading: true
    }
  },
  methods: {
    fetchData: function () {
      this.tableLoading = true
      var call = '/getPEAChecks/' + this.peaId + '?page=' + this.currentPage + '&pageSize=' + this.pageSize
      this.$axios.get(call).then(response => {
        this.checkData = response.data.results
        this.resultTotal = response.data.totalRecords
        this.tableLoading = false
        this.$emit('fetchComplete')
      }).catch(response => {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
        helperMethods.showNotification(this.$parent, 'Error retrieving Check Information', response.body, 'error', 30000)
        this.$emit('fetchComplete')
      })
    },
    updatePEAChecks () {
      var call = '/updatePEAChecks/' + this.peaId
      var toSend = JSON.stringify(this.checkData)
      return new Promise((resolve, reject) => {
        this.$axios.post(call, toSend, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(response => resolve(response))
          .catch(response => {
            helperMethods.showNotification(this.$parent, 'Error updating Check Information', response.body, 'error', 30000)
            reject(response)
          })
      })
    },
    startUp () {
      this.fetchData()
    }
  },
  mounted () {
    this.startUp()
  },
  watch: {
    // watch for route change - going from pea/4 to pea/0
    '$route': 'startUp'
  }
}
</script>

<style>

  .peaCheckTable .cell {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .peaCheckTable textarea {
    margin: 10px 0;
  }

  .checks-panel {
    padding-bottom: 30px;
  }
</style>

<style scoped>
  a {
      color: #00a9ce !important;
  }
</style>
